<template>
  <div class="pagina ativa" id="paginaCrm">
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;border-bottom:2px solid #4a5c2f;padding-bottom:10px;flex-wrap:wrap;gap:10px;">
      <div style="display:flex;align-items:center;gap:8px;font-size:22px;font-weight:bold;color:#4a5c2f;"><ClipboardList :size="22" /> CRM</div>
      <div style="display:flex;gap:8px;">
        <button @click="abrirModalCliente(null)" style="margin:0;padding:8px 16px;font-size:13px;background:#27ae60;">+ Novo Cliente</button>
        <button @click="carregarCRM" style="display:inline-flex;align-items:center;gap:5px;margin:0;padding:8px 16px;font-size:13px;"><RefreshCw :size="13" /> Atualizar</button>
      </div>
    </div>

    <div class="crm-overview">
      <div class="crm-overview-copy"><span>Visão geral</span><strong>Pipeline comercial</strong><small>Acompanhe oportunidades e próximos movimentos.</small></div>
      <div class="crm-overview-metrics">
        <div class="crm-metric"><span class="crm-metric-dot total"></span><div><strong>{{ leads.length }}</strong><small>Clientes</small></div></div>
        <div class="crm-metric"><span class="crm-metric-dot active"></span><div><strong>{{ vinculados }}</strong><small>Com vendedor</small></div></div>
        <div class="crm-metric"><span class="crm-metric-dot proposal"></span><div><strong>{{ listaPorEtapa('reuniao').length }}</strong><small>Em negociação</small></div></div>
        <div class="crm-metric"><span class="crm-metric-dot won"></span><div><strong>{{ vendasFechadas }}</strong><small>Convertidos</small></div></div>
      </div>
    </div>
    <div class="crm-searchbar"><span class="crm-search-icon"><Search :size="15" /></span><input type="text" v-model="filtro.busca" placeholder="Buscar cliente por nome, CPF, telefone ou e-mail..." /><span class="crm-search-hint">Use os filtros abaixo para refinar</span></div>

    <div style="background:white;border-radius:10px;padding:14px 18px;box-shadow:0 2px 8px rgba(0,0,0,0.08);margin-bottom:16px;display:flex;gap:14px;flex-wrap:wrap;align-items:flex-end;">
      <div><label style="font-size:11px;">Data de</label><input type="date" v-model="filtro.dataInicio" style="width:150px;" /></div>
      <div><label style="font-size:11px;">Até</label><input type="date" v-model="filtro.dataFim" style="width:150px;" /></div>
      <div><label style="font-size:11px;">Tipo</label><select v-model="filtro.tipo" style="width:130px;"><option value="">Todos</option><option value="Veículo">Veículo</option><option value="Imóvel">Imóvel</option></select></div>
      <div><label style="font-size:11px;">Mostrar</label><select v-model="filtro.limite" style="width:130px;"><option value="30">30 por coluna</option><option value="50">50 por coluna</option><option value="100">100 por coluna</option><option value="0">Todos</option></select></div>
      <div><label style="font-size:11px;">Buscar</label><input type="text" v-model="filtro.busca" placeholder="Nome, CPF..." style="width:180px;" /></div>
      <button @click="limparFiltros" style="margin:0;padding:9px 16px;font-size:13px;background:#888;">Limpar</button>
    </div>

    <div v-if="filtroVendedorAtivo" style="background:#eaf4ff;border:1.5px solid #2980b9;border-radius:8px;padding:8px 14px;margin-bottom:14px;display:flex;justify-content:space-between;align-items:center;font-size:13px;color:#0369a1;">
      Mostrando leads de <strong>&nbsp;{{ filtroVendedorAtivo }}</strong>
      <button @click="filtroVendedorAtivo = ''" style="margin:0;padding:4px 12px;font-size:11px;background:#c0392b;">Remover filtro</button>
    </div>

    <div class="status" :class="statusMsg.tipo === 'sucesso' ? 'sucesso' : (statusMsg.tipo === 'erro' ? 'erro-msg' : '')">{{ statusMsg.texto }}</div>

    <div v-if="selecionados.length" style="display:flex;background:#f0f9ff;border:1.5px solid #2980b9;border-radius:10px;padding:10px 16px;margin-bottom:16px;align-items:center;justify-content:space-between;gap:10px;flex-wrap:wrap;">
      <span style="font-size:13px;color:#0369a1;font-weight:bold;">{{ selecionados.length }} lead{{ selecionados.length !== 1 ? 's' : '' }} selecionado{{ selecionados.length !== 1 ? 's' : '' }}</span>
      <div style="display:flex;gap:8px;">
        <button @click="abrirModalLinkVendedor(null)" style="display:inline-flex;align-items:center;gap:5px;margin:0;padding:7px 16px;font-size:12px;background:#2980b9;"><UserRound :size="13" /> Vincular Vendedor</button>
        <button @click="desvincularSelecionados" style="display:inline-flex;align-items:center;gap:5px;margin:0;padding:7px 16px;font-size:12px;background:#e67e22;"><X :size="13" /> Desvincular</button>
        <button @click="limparSelecao" style="margin:0;padding:7px 16px;font-size:12px;background:#888;">Limpar Seleção</button>
      </div>
    </div>

    <div v-if="ehAdmin" style="background:white;border-radius:10px;padding:18px;box-shadow:0 2px 8px rgba(0,0,0,0.08);margin-bottom:16px;">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px;cursor:pointer;" @click="resumoAberto = !resumoAberto">
        <div style="display:flex;align-items:center;gap:7px;font-weight:bold;color:#4a5c2f;font-size:15px;"><BarChart3 :size="16" /> Resumo Geral</div>
        <span style="font-size:12px;color:#888;">{{ resumoAberto ? '▼ Ocultar' : '▶ Mostrar' }}</span>
      </div>
      <div v-show="resumoAberto">
        <div class="grid-cards" style="margin-bottom:16px;">
          <div class="card"><div class="card-label">Total de Leads</div><div class="card-valor">{{ leads.length }}</div></div>
          <div class="card"><div class="card-label">Vinculados a Vendedor</div><div class="card-valor" style="color:#2980b9;">{{ vinculados }}</div></div>
          <div class="card"><div class="card-label">Sem Vínculo</div><div class="card-valor" style="color:#e67e22;">{{ naoVinculados }}</div></div>
          <div class="card"><div class="card-label">Vendas Fechadas</div><div class="card-valor" style="color:#27ae60;">{{ vendasFechadas }}</div></div>
        </div>
        <div style="overflow-x:auto;">
          <table class="tabela-dash">
            <thead><tr><th>Vendedor</th><th>Total</th><th v-for="et in etapas" :key="et.chave">{{ et.nome }}</th></tr></thead>
            <tbody>
              <tr v-for="n in resumoNomes" :key="n">
                <td style="font-weight:bold;cursor:pointer;color:#2980b9;text-decoration:underline;" @click="filtrarPorVendedor(n)" title="Clique para filtrar">{{ n }}</td>
                <td style="font-weight:bold;">{{ resumoPorVendedor[n].total }}</td>
                <td v-for="et in etapas" :key="et.chave">
                  <span v-if="resumoPorVendedor[n][et.chave] > 0" :style="{ background: et.cor, color: 'white', padding: '2px 9px', borderRadius: '10px', fontSize: '12px', fontWeight: 'bold' }">{{ resumoPorVendedor[n][et.chave] }}</span>
                  <span v-else style="color:#ccc;">0</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div id="crmBoard" style="display:grid;grid-template-columns:repeat(5,1fr);gap:12px;overflow-x:auto;">
      <div class="crm-coluna" v-for="et in etapas" :key="et.chave" @drop="onDrop($event, et.chave)" @dragover.prevent>
        <div class="crm-coluna-titulo" :style="{ background: et.cor }">
          <span>{{ et.nome }} {{ listaPorEtapa(et.chave).length }}</span>
          <button v-if="ehAdmin" class="crm-btn-selecionar-todos" @click="selecionarTodosColuna(et.chave)">{{ colunaTodosMarcados(et.chave) ? 'Desmarcar todos' : 'Selecionar todos' }}</button>
        </div>
        <div class="crm-lista">
          <div v-for="l in listaExibidaPorEtapa(et.chave)" :key="l.id" class="crm-card" :class="{ travado: l.travado }" :draggable="!l.travado" @dragstart="onDragStart($event, l.id)" @click="abrirModalCliente(l)">
            <input v-if="ehAdmin" type="checkbox" :checked="selecionados.includes(String(l.id))" @click.stop @change="toggleSelecao(l.id, $event.target.checked)" style="float:right;width:16px;height:16px;cursor:pointer;" />
            <div class="crm-card-nome" style="display:flex;align-items:center;gap:5px;">#{{ l.id }} {{ l.nome }} ({{ l.dataChegada }})<Lock v-if="l.travado" :size="12" /></div>
            <div v-if="l.cpf" class="crm-card-info">{{ l.cpf }}</div>
            <div v-if="l.telefone" class="crm-card-info">{{ l.telefone }}</div>
            <div v-if="l.email" class="crm-card-info">{{ l.email }}</div>
            <div v-if="l.valorCredito || l.categoria" class="crm-card-info">{{ l.valorCredito ? 'R$ ' + l.valorCredito : '' }}{{ l.categoria ? ' — ' + l.categoria : '' }}</div>
            <div v-if="l.qtdParcelas && l.valorParcela" class="crm-card-info">{{ l.qtdParcelas }}x R$ {{ l.valorParcela }}</div>
            <div v-if="l.origem" class="crm-card-info" style="display:flex;align-items:center;gap:4px;"><Tag :size="11" /> {{ l.origem }}</div>
            <div v-if="l.observacoes" class="crm-card-info" style="font-style:italic;color:#888;">"{{ l.observacoes.length > 60 ? l.observacoes.slice(0, 60) + '…' : l.observacoes }}"</div>
            <div v-if="l.vendedor" class="crm-card-info" style="display:flex;align-items:center;gap:4px;color:#4a5c2f;font-weight:bold;"><UserRound :size="12" /> {{ l.vendedor }}</div>
            <select v-if="!l.travado" class="crm-card-mover-mobile" :value="l.etapa" @click.stop @change="onSelecionarMoverEtapa($event, l)">
              <option v-for="et2 in etapas" :key="et2.chave" :value="et2.chave">Mover para: {{ et2.nome }}</option>
            </select>
            <div class="crm-card-btns">
              <button @click.stop="abrirModalCliente(l)" style="display:inline-flex;align-items:center;gap:4px;background:#4a5c2f;"><Pencil :size="12" /> Editar</button>
              <button v-if="ehAdmin" @click.stop="abrirModalLinkVendedor(l.id)" style="background:#2980b9;">Vincular</button>
              <button v-if="l.etapa === 'venda' && l.travado && ehAdmin" @click.stop="desfazerVenda(l.id)" style="background:#c0392b;">Desfazer</button>
              <button v-if="ehAdmin" @click.stop="excluirLead(l.id)" style="background:#888;">Excluir</button>
            </div>
          </div>
          <div v-if="limiteInt > 0 && listaPorEtapa(et.chave).length > limiteInt" style="text-align:center;font-size:11px;color:#888;padding:10px;">
            +{{ listaPorEtapa(et.chave).length - limiteInt }} lead(s) ocultos — aumente o filtro "Mostrar" para ver mais
          </div>
        </div>
      </div>
    </div>

    <canvas ref="confetti" style="position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:9999;" :style="{ display: confettiAtivo ? 'block' : 'none' }"></canvas>

    <div v-if="modalVendedorAberto" class="app-drawer-overlay">
      <div class="app-drawer">
        <h3>{{ linkLeadId ? 'Vincular Vendedor' : 'Vincular Vendedor a ' + selecionados.length + ' lead(s)' }}</h3>
        <label>VENDEDOR</label>
        <select v-model="linkVendedorSelecionado" style="width:100%;">
          <option value="">Nenhum</option>
          <option v-for="u in vendedoresUsuarios" :key="u.nome" :value="u.nome">{{ u.nome }}</option>
        </select>
        <div class="app-drawer-acoes">
          <button @click="modalVendedorAberto = false" style="background:#888;">Cancelar</button>
          <button @click="salvarLinkVendedor">Salvar</button>
        </div>
      </div>
    </div>

    <div v-if="modalClienteAberto" class="app-drawer-overlay">
      <div class="app-drawer">
        <h3>{{ clienteForm.id ? 'Editar Cliente' : 'Novo Cliente' }}</h3>
        <label>NOME *</label>
        <input type="text" v-model="clienteForm.nome" placeholder="Nome completo" />
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">
          <div><label>TELEFONE</label><input type="text" v-model="clienteForm.telefone" placeholder="(11) 99999-9999" /></div>
          <div><label>CPF</label><input type="text" v-model="clienteForm.cpf" placeholder="000.000.000-00" /></div>
        </div>
        <label>E-MAIL</label>
        <input type="text" v-model="clienteForm.email" placeholder="cliente@email.com" />
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">
          <div><label>CATEGORIA</label>
            <select v-model="clienteForm.categoria">
              <option value="Veículo">Veículo</option>
              <option value="Imóvel">Imóvel</option>
            </select>
          </div>
          <div><label>ORIGEM DO LEAD</label>
            <select v-model="clienteForm.origem">
              <option value="">Não informado</option>
              <option value="Indicação">Indicação</option>
              <option value="Anúncio">Anúncio</option>
              <option value="Redes Sociais">Redes Sociais</option>
              <option value="Site">Site</option>
              <option value="Outro">Outro</option>
            </select>
          </div>
        </div>
        <label>VALOR DE CRÉDITO (R$)</label>
        <input type="text" inputmode="decimal" v-model="clienteForm.valorCredito" @input="mascaraValor($event, 'valorCredito')" placeholder="Ex: 80.000,00" />
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">
          <div><label>VALOR DE PARCELA (R$)</label><input type="text" inputmode="decimal" v-model="clienteForm.valorParcela" @input="mascaraValor($event, 'valorParcela')" placeholder="Ex: 800,00" /></div>
          <div><label>Nº DE PARCELAS</label><input type="text" inputmode="numeric" v-model="clienteForm.qtdParcelas" @input="mascaraInteiro($event, 'qtdParcelas')" placeholder="Ex: 100" /></div>
        </div>
        <label>OBSERVAÇÕES</label>
        <textarea v-model="clienteForm.observacoes" placeholder="Detalhes da negociação, preferências do cliente..." style="width:100%;min-height:70px;padding:9px;border:1px solid #ddd;border-radius:6px;font-size:13px;resize:vertical;"></textarea>
        <div v-if="ehAdmin" style="margin-top:8px;">
          <label>VENDEDOR RESPONSÁVEL</label>
          <select v-model="clienteForm.vendedor">
            <option value="">Nenhum</option>
            <option v-for="u in vendedoresUsuarios" :key="u.nome" :value="u.nome">{{ u.nome }}</option>
          </select>
        </div>
        <div class="status" :class="statusCliente.tipo === 'sucesso' ? 'sucesso' : (statusCliente.tipo === 'erro' ? 'erro-msg' : '')">{{ statusCliente.texto }}</div>
        <div class="app-drawer-acoes">
          <button @click="modalClienteAberto = false" style="background:#888;">Cancelar</button>
          <button @click="salvarCliente">Salvar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGet, apiPost, apiDelete, getSession } from '../api'
import { setPendingVenda } from '../crmHelpers'
import { ClipboardList, RefreshCw, Search, UserRound, X, Lock, Tag, Pencil, BarChart3 } from 'lucide-vue-next'

const ETAPAS = [
  { chave: 'leads', nome: 'Leads', cor: '#607d8b' },
  { chave: 'atendimento', nome: 'Atendimento', cor: '#f39c12' },
  { chave: 'reuniao', nome: 'Reunião', cor: '#2980b9' },
  { chave: 'venda', nome: 'Venda Feita', cor: '#27ae60' },
  { chave: 'desistiu', nome: 'Desistiu', cor: '#c0392b' }
]

function parseDataBR(s) {
  if (!s) return null
  const p = s.split('/')
  return p.length === 3 ? new Date(+p[2], +p[1] - 1, +p[0]) : null
}
function normalizar(s) {
  return (s || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
}
function clienteFormVazio() {
  return { id: null, nome: '', telefone: '', cpf: '', email: '', categoria: 'Veículo', origem: '', valorCredito: '', valorParcela: '', qtdParcelas: '', observacoes: '', vendedor: '' }
}

export default {
  name: 'PaginaCrm',
  components: { ClipboardList, RefreshCw, Search, UserRound, X, Lock, Tag, Pencil, BarChart3 },
  data() {
    return {
      leads: [],
      etapas: ETAPAS,
      filtro: { dataInicio: '', dataFim: '', idInicio: '', idFim: '', tipo: '', limite: '30', busca: '' },
      filtroVendedorAtivo: '',
      selecionados: [],
      resumoAberto: true,
      statusMsg: { texto: '', tipo: '' },
      dragId: null,
      modalVendedorAberto: false,
      linkLeadId: null,
      linkVendedorSelecionado: '',
      vendedoresUsuarios: [],
      confettiAtivo: false,
      modalClienteAberto: false,
      clienteForm: clienteFormVazio(),
      statusCliente: { texto: '', tipo: '' }
    }
  },
  computed: {
    ehAdmin() { return getSession().perfil === 'admin' },
    nomeUsuario() { return getSession().nome },
    limiteInt() { return parseInt(this.filtro.limite) || 0 },
    dadosFiltrados() {
      let d = this.ehAdmin ? this.leads.slice() : this.leads.filter(l => l.vendedor === this.nomeUsuario)
      if (this.ehAdmin && this.filtroVendedorAtivo) {
        d = d.filter(l => this.filtroVendedorAtivo === '— Sem vínculo —' ? !l.vendedor : l.vendedor === this.filtroVendedorAtivo)
      }
      if (this.filtro.dataInicio) {
        const d1 = new Date(this.filtro.dataInicio)
        d = d.filter(l => { const dt = parseDataBR(l.dataChegada); return dt && dt >= d1 })
      }
      if (this.filtro.dataFim) {
        const d2 = new Date(this.filtro.dataFim); d2.setHours(23, 59, 59)
        d = d.filter(l => { const dt = parseDataBR(l.dataChegada); return dt && dt <= d2 })
      }
      if (this.filtro.tipo) d = d.filter(l => normalizar(l.categoria).indexOf(normalizar(this.filtro.tipo)) > -1)
      if (this.filtro.busca) {
        const b = this.filtro.busca.toLowerCase()
        d = d.filter(l => ((l.nome || '') + (l.cpf || '') + (l.email || '') + (l.telefone || '')).toLowerCase().indexOf(b) > -1)
      }
      return d
    },
    vinculados() { return this.leads.filter(l => l.vendedor).length },
    naoVinculados() { return this.leads.length - this.vinculados },
    vendasFechadas() { return this.leads.filter(l => l.etapa === 'venda').length },
    resumoPorVendedor() {
      const por = {}
      this.leads.forEach(l => {
        const v = l.vendedor || '— Sem vínculo —'
        if (!por[v]) por[v] = { leads: 0, atendimento: 0, reuniao: 0, venda: 0, desistiu: 0, total: 0 }
        por[v][l.etapa || 'leads']++
        por[v].total++
      })
      return por
    },
    resumoNomes() {
      const por = this.resumoPorVendedor
      return Object.keys(por).sort((a, b) => {
        if (a === '— Sem vínculo —') return 1
        if (b === '— Sem vínculo —') return -1
        return por[b].total - por[a].total
      })
    }
  },
  created() {
    this.carregarCRM()
  },
  methods: {
    listaPorEtapa(etapa) {
      return this.dadosFiltrados.filter(l => (l.etapa || 'leads') === etapa)
    },
    listaExibidaPorEtapa(etapa) {
      const lista = this.listaPorEtapa(etapa)
      return this.limiteInt > 0 ? lista.slice(0, this.limiteInt) : lista
    },
    colunaTodosMarcados(etapa) {
      const ids = this.listaExibidaPorEtapa(etapa).map(l => String(l.id))
      return ids.length > 0 && ids.every(id => this.selecionados.includes(id))
    },
    async carregarCRM() {
      const r = await apiGet('crm/leads/listar')
      if (r.sucesso) this.leads = r.leads
    },
    async carregarVendedores() {
      const r = await apiGet('usuarios/listar')
      if (r.sucesso) this.vendedoresUsuarios = r.usuarios
    },
    async abrirModalCliente(lead) {
      this.statusCliente = { texto: '', tipo: '' }
      if (this.ehAdmin && !this.vendedoresUsuarios.length) await this.carregarVendedores()
      if (lead) {
        if (!this.ehAdmin && lead.vendedor !== this.nomeUsuario) return
        this.clienteForm = {
          id: lead.id, nome: lead.nome, telefone: lead.telefone || '', cpf: lead.cpf || '', email: lead.email || '',
          categoria: lead.categoria || 'Veículo', origem: lead.origem || '', valorCredito: lead.valorCredito || '',
          valorParcela: lead.valorParcela || '', qtdParcelas: lead.qtdParcelas || '', observacoes: lead.observacoes || '',
          vendedor: lead.vendedor || ''
        }
      } else {
        this.clienteForm = clienteFormVazio()
        if (!this.ehAdmin) this.clienteForm.vendedor = this.nomeUsuario
      }
      this.modalClienteAberto = true
    },
    mascaraValor(e, campo) {
      let d = e.target.value.replace(/\D/g, '')
      if (!d) { this.clienteForm[campo] = ''; return }
      const n = (parseInt(d) / 100).toFixed(2)
      this.clienteForm[campo] = n.replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    },
    mascaraInteiro(e, campo) {
      this.clienteForm[campo] = e.target.value.replace(/\D/g, '')
    },
    async salvarCliente() {
      if (!this.clienteForm.nome || !this.clienteForm.nome.trim()) {
        this.statusCliente = { texto: 'Informe o nome do cliente.', tipo: 'erro' }
        return
      }
      this.statusCliente = { texto: 'Salvando...', tipo: '' }
      const r = await apiPost('crm/leads/salvar', { ...this.clienteForm })
      if (r.sucesso) {
        this.modalClienteAberto = false
        this.statusMsg = { texto: this.clienteForm.id ? 'Cliente atualizado!' : 'Cliente cadastrado!', tipo: 'sucesso' }
        this.carregarCRM()
      } else {
        this.statusCliente = { texto: r.mensagem || 'Erro ao salvar.', tipo: 'erro' }
      }
    },
    limparFiltros() {
      this.filtro = { dataInicio: '', dataFim: '', idInicio: '', idFim: '', tipo: '', limite: '30', busca: '' }
    },
    filtrarPorVendedor(nome) {
      this.filtroVendedorAtivo = this.filtroVendedorAtivo === nome ? '' : nome
    },
    toggleSelecao(id, marcado) {
      const sid = String(id)
      const idx = this.selecionados.indexOf(sid)
      if (marcado && idx === -1) this.selecionados.push(sid)
      else if (!marcado && idx > -1) this.selecionados.splice(idx, 1)
    },
    limparSelecao() {
      this.selecionados = []
    },
    selecionarTodosColuna(etapa) {
      const ids = this.listaExibidaPorEtapa(etapa).map(l => String(l.id))
      const todosMarcados = ids.length > 0 && ids.every(id => this.selecionados.includes(id))
      if (todosMarcados) this.selecionados = this.selecionados.filter(id => !ids.includes(id))
      else ids.forEach(id => { if (!this.selecionados.includes(id)) this.selecionados.push(id) })
    },
    onDragStart(ev, id) {
      this.dragId = id
      ev.dataTransfer.setData('text', id)
    },
    async onDrop(ev, novaEtapa) {
      if (!this.dragId) return
      const id = this.dragId
      this.dragId = null
      await this.moverLead(id, novaEtapa)
    },
    async moverLead(id, novaEtapa) {
      const lead = this.leads.find(l => String(l.id) === String(id))
      if (!lead || lead.travado) return
      if (lead.etapa === novaEtapa) return
      if (!this.ehAdmin && lead.vendedor !== this.nomeUsuario) return

      if (novaEtapa === 'venda') {
        if (!window.confirm('Confirmar consolidação da venda para "' + lead.nome + '"?\n\nO card será travado, a tela de Lançar Venda vai abrir com os dados do cliente e só o admin poderá desfazer.')) return
        const r = await apiPost('crm/leads/consolidar-venda', { id })
        if (r.sucesso) {
          lead.etapa = 'venda'
          lead.travado = true
          this.dispararConfete()
          setPendingVenda({
            nomeCliente: lead.nome,
            cpf: lead.cpf || '',
            valor: lead.valorCredito || '',
            categoria: lead.categoria || '',
            observacao: 'Origem: CRM #' + lead.id + (lead.observacoes ? ' — ' + lead.observacoes : '')
          })
          setTimeout(() => { window.dispatchEvent(new CustomEvent('siscon-navigate', { detail: 'vendas' })) }, 600)
        }
        return
      }

      const r = await apiPost('crm/leads/mover', { id, novaEtapa })
      if (r.sucesso) lead.etapa = novaEtapa
      else window.alert(r.mensagem || 'Erro ao mover.')
    },
    onSelecionarMoverEtapa(ev, lead) {
      const novaEtapa = ev.target.value
      ev.target.value = lead.etapa
      if (novaEtapa && novaEtapa !== lead.etapa) this.moverLead(lead.id, novaEtapa)
    },
    async desfazerVenda(id) {
      if (!window.confirm('Desfazer a venda deste lead? Ele voltará para "Reunião".')) return
      const r = await apiPost('crm/leads/desfazer-venda', { id })
      if (r.sucesso) this.carregarCRM()
      else window.alert(r.mensagem || 'Erro.')
    },
    async excluirLead(id) {
      if (!window.confirm('Excluir este lead permanentemente?')) return
      await apiDelete('crm/leads/excluir', { id })
      this.carregarCRM()
    },
    async abrirModalLinkVendedor(id) {
      this.linkLeadId = id
      this.linkVendedorSelecionado = ''
      await this.carregarVendedores()
      this.modalVendedorAberto = true
    },
    async desvincularSelecionados() {
      if (!this.selecionados.length) return
      if (!window.confirm('Desvincular ' + this.selecionados.length + ' lead(s) do vendedor atual?')) return
      this.statusMsg = { texto: 'Desvinculando...', tipo: '' }
      const r = await apiPost('crm/leads/linkar-vendedor', { ids: this.selecionados.map(id => parseInt(id)), vendedor: null })
      this.selecionados = []
      this.statusMsg = { texto: (r.atualizados || 0) + ' lead(s) desvinculado(s)!', tipo: 'sucesso' }
      this.carregarCRM()
    },
    async salvarLinkVendedor() {
      const ids = this.linkLeadId ? [this.linkLeadId] : this.selecionados.slice()
      if (!ids.length) return
      this.statusMsg = { texto: 'Vinculando ' + ids.length + ' lead(s)...', tipo: '' }
      const r = await apiPost('crm/leads/linkar-vendedor', { ids: ids.map(id => parseInt(id)), vendedor: this.linkVendedorSelecionado || null })
      this.modalVendedorAberto = false
      this.selecionados = []
      this.statusMsg = { texto: (r.atualizados || 0) + ' lead(s) vinculado(s)!', tipo: 'sucesso' }
      this.carregarCRM()
    },
    dispararConfete() {
      const canvas = this.$refs.confetti
      if (!canvas) return
      this.confettiAtivo = true
      canvas.width = window.innerWidth
      canvas.height = window.innerHeight
      const ctx = canvas.getContext('2d')
      const cores = ['#f39c12', '#27ae60', '#2980b9', '#c0392b', '#8e44ad', '#f1c40f']
      const particulas = []
      for (let i = 0; i < 150; i++) {
        particulas.push({
          x: Math.random() * canvas.width, y: -20,
          vx: (Math.random() - 0.5) * 6, vy: Math.random() * 3 + 2,
          cor: cores[Math.floor(Math.random() * cores.length)],
          tam: Math.random() * 6 + 4, rot: Math.random() * 360, vrot: (Math.random() - 0.5) * 10
        })
      }
      let frames = 0
      const tick = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height)
        particulas.forEach(p => {
          p.x += p.vx; p.y += p.vy; p.vy += 0.05; p.rot += p.vrot
          ctx.save()
          ctx.translate(p.x, p.y); ctx.rotate(p.rot * Math.PI / 180)
          ctx.fillStyle = p.cor
          ctx.fillRect(-p.tam / 2, -p.tam / 2, p.tam, p.tam)
          ctx.restore()
        })
        frames++
        if (frames < 180) requestAnimationFrame(tick)
        else { this.confettiAtivo = false; ctx.clearRect(0, 0, canvas.width, canvas.height) }
      }
      tick()
    }
  }
}
</script>

<style>
#paginaCrm>div:first-child{border:0!important;padding:0!important;margin-bottom:22px!important;align-items:flex-start!important}
#paginaCrm>div:first-child>div:first-child{font-size:26px!important;font-weight:850!important;letter-spacing:-.045em;color:var(--ink-950)!important}
#paginaCrm>div:first-child>div:first-child:after{content:"Acompanhe seus clientes em cada etapa do relacionamento";display:block;margin-top:5px;font-size:12px;font-weight:500;letter-spacing:0;color:var(--ink-500)}
#paginaCrm>div:first-child button{border-radius:9px!important;box-shadow:none!important;font-weight:700!important}
#paginaCrm .crm-searchbar + div{border:1px solid var(--line)!important;border-radius:14px!important;background:#fff!important;box-shadow:var(--shadow-sm)!important;padding:16px 18px!important}
#paginaCrm .crm-searchbar + div>div{min-width:130px}
#paginaCrm .crm-overview{display:flex;align-items:center;justify-content:space-between;gap:20px;margin:0 0 14px;padding:20px 22px;border:1px solid #dfe7dc;border-radius:16px;background:linear-gradient(115deg,#f4f7ed 0%,#fff 62%);box-shadow:0 3px 12px rgba(46,61,24,.06)}
#paginaCrm .crm-overview-copy{display:flex;flex-direction:column;min-width:190px}.crm-overview-copy span{color:var(--brand-600);font-size:10px;font-weight:800;text-transform:uppercase;letter-spacing:.12em}.crm-overview-copy strong{margin-top:4px;color:var(--ink-950);font-size:20px;letter-spacing:-.035em}.crm-overview-copy small{margin-top:4px;color:var(--ink-500);font-size:11px}
#paginaCrm .crm-overview-metrics{display:grid;grid-template-columns:repeat(4,minmax(110px,1fr));gap:9px;flex:1;max-width:640px}.crm-metric{display:flex;align-items:center;gap:9px;padding:10px 12px;border-left:1px solid #e4ebe0}.crm-metric-dot{width:8px;height:8px;flex:none;border-radius:50%;background:#8d9b83;box-shadow:0 0 0 4px #e6edde}.crm-metric-dot.active{background:#557c39;box-shadow:0 0 0 4px #e4efdc}.crm-metric-dot.proposal{background:#c38a2d;box-shadow:0 0 0 4px #fbefd5}.crm-metric-dot.won{background:#2f8b55;box-shadow:0 0 0 4px #dff0e5}.crm-metric div{display:flex;flex-direction:column}.crm-metric strong{font-size:19px;line-height:1;color:var(--ink-950)}.crm-metric small{margin-top:4px;color:var(--ink-500);font-size:9px;white-space:nowrap}
#paginaCrm .crm-searchbar{display:flex;align-items:center;gap:10px;margin-bottom:12px;padding:0 14px;height:46px;border:1px solid #dce6da;border-radius:11px;background:#fff;box-shadow:0 2px 8px rgba(46,61,24,.04)}.crm-search-icon{color:var(--brand-700);font-size:24px;line-height:1;transform:rotate(-20deg)}.crm-searchbar input{flex:1!important;min-width:0!important;height:42px!important;margin:0!important;padding:0!important;border:0!important;background:transparent!important;box-shadow:none!important;font-size:12px!important}.crm-searchbar input:focus{outline:0!important}.crm-search-hint{color:#9aa59a;font-size:10px;white-space:nowrap}
#paginaCrm .crm-searchbar + div input,#paginaCrm .crm-searchbar + div select{margin:4px 0 0!important;background:#fbfcfa!important}
#paginaCrm .status{min-height:8px}
#paginaCrm .crm-coluna{background:#edf1ed;border:1px solid #e0e6e0;border-radius:14px;padding:8px;min-height:500px;display:flex;flex-direction:column;box-shadow:inset 0 1px 0 rgba(255,255,255,.7)}
#paginaCrm .crm-coluna-titulo{color:white;font-size:11px;font-weight:800;padding:11px 12px;border-radius:10px;margin-bottom:10px;display:flex;justify-content:space-between;align-items:center;gap:6px;flex-wrap:wrap;letter-spacing:.02em;text-transform:uppercase;box-shadow:0 3px 8px rgba(16,42,37,.10)}
#paginaCrm .crm-btn-selecionar-todos{background:rgba(255,255,255,.2);border:1px solid rgba(255,255,255,.3);color:white;font-size:9px;padding:4px 7px;border-radius:7px;cursor:pointer;white-space:nowrap}
#paginaCrm .crm-lista{flex:1;display:flex;flex-direction:column;gap:9px;min-height:100px;padding:1px}
#paginaCrm .crm-card{position:relative;background:#fff;border:1px solid #e1e8e2;border-left:3px solid var(--brand-500);border-radius:12px;padding:13px 12px;box-shadow:0 2px 7px rgba(16,42,37,.06);cursor:grab;font-size:12px;transition:transform .16s,box-shadow .16s,border-color .16s}
#paginaCrm .crm-card:hover{transform:translateY(-2px);border-color:#b8cbb8;box-shadow:0 8px 18px rgba(16,42,37,.11)}
#paginaCrm .crm-card.travado{border-left-color:#5c7239;background:#f6faef;cursor:not-allowed;opacity:.92}
#paginaCrm .crm-card-nome{font-weight:800;color:var(--ink-950);font-size:13px;line-height:1.35;margin-bottom:8px;padding-right:20px}
#paginaCrm .crm-card-info{color:var(--ink-500);font-size:10px;margin-bottom:4px;line-height:1.35}
#paginaCrm .crm-card-info[style*="font-style"]{padding:7px 8px;margin-top:7px;background:#f7f9f6;border-radius:7px;color:var(--ink-500)!important}
#paginaCrm .crm-card-info[style*="font-weight:bold"]{display:inline-flex;margin-top:6px;padding:4px 8px;border-radius:6px;background:var(--brand-50);color:var(--brand-700)!important}
#paginaCrm .crm-card-btns{display:flex;gap:5px;margin-top:11px;padding-top:9px;border-top:1px solid #eef2ee;flex-wrap:wrap}
#paginaCrm .crm-card-btns button{padding:5px 8px;font-size:9px;margin:0;border-radius:7px!important;box-shadow:none!important}
#paginaCrm>div[style*="position:fixed"]>div{border-radius:16px!important;box-shadow:0 20px 60px rgba(16,42,37,.2)!important;border:1px solid var(--line)}
@media(max-width:1100px){#crmBoard{grid-template-columns:repeat(5,minmax(220px,1fr))!important;overflow-x:auto;padding-bottom:6px}.crm-coluna{min-width:220px}}
@media(max-width:768px){#paginaCrm>div:first-child>div:last-child{width:100%;display:grid!important;grid-template-columns:1fr 1fr;gap:7px!important}#paginaCrm>div:first-child button{width:100%}#paginaCrm .crm-searchbar + div{padding:13px!important}#paginaCrm .crm-searchbar + div>div{min-width:calc(50% - 7px);flex:1}#crmBoard{grid-template-columns:repeat(5,minmax(255px,1fr))!important}.crm-coluna{min-height:440px}}
@media(max-width:768px){#paginaCrm .crm-overview{display:block;padding:16px}.crm-overview-copy strong{font-size:18px}.crm-overview-metrics{grid-template-columns:repeat(2,1fr)!important;max-width:none!important;margin-top:14px;gap:0!important}.crm-metric{padding:9px 5px;border-top:1px solid #e4ebe0;border-left:0}.crm-search-hint{display:none}.crm-searchbar{height:44px!important}}
#paginaCrm .crm-card-mover-mobile{display:none}
@media(hover:none) and (pointer:coarse){#paginaCrm .crm-card-mover-mobile{display:block;width:100%;margin-top:9px;padding:7px 8px;font-size:10px;border:1px solid #dce6da;border-radius:7px;background:#fbfcfa;color:var(--ink-500)}}
</style>
